// eslint-disable-next-line no-use-before-define
import React from "react";
import { ModalItemProps } from "../../interfaces/components/modal.interface";
import Button from "../button/button";

const Modal = ({ handleClose, children }: ModalItemProps) => (
  <div data-test="modal-wrapper">
    <div className="modal">
      <div className="modal__main">
        <div className="modal__main--close col-xs-2">
          <Button title="X" onClickHandler={handleClose} />
        </div>
        <div className="modal__main--children">{children}</div>
      </div>
    </div>
  </div>
);
export default Modal;
